<div class="row row-header" [ngClass]="breadcrumbCssClass">
  <div class="col-lg-12 col-md-12">
      <app-header-breadcrumb [breadcrumb]="breadcrumb" [supplierName]="currentUser?.companyName"></app-header-breadcrumb>
  </div>
</div>
